import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import styled from 'styled-components';
import { useEffect, useState } from 'react';

import * as Server from 'assets/js/Server';
import useDidMountEffect from '../../assets/js/useDidMountEffect';
import * as Common from '../../assets/js/Common';

export default function ClientComplaintWrite() {
  const navigate = useNavigate();
  const location = useLocation();

  // state가 없을 경우를 대비해 옵셔널 체이닝(?.)이나 기본값을 사용합니다.
  const resultData = location.state?.data;

  const [param, setParam] = useState({
    seq: '',
    reply: ''
  });
  const [isSubmit, setIsSubmit] = useState(false);

  const patchComplaint = () => {
    if (param.fkCustDetailSeq === '') {
      alert('Area is required');
      return false;
    }

    if (param.complaint === '') {
      alert('Complaint is required');
      return false;
    }

    setParam(() => {
      return {
        ...param,
        seq : resultData.seq
      }
    })

    if (!isSubmit) {
      setIsSubmit(true);
      Server.sendPatch('customer/hq/complaint', param, patchDataCallback).then();
    }

  };

  const patchDataCallback = res => {
    setIsSubmit(false);

    Common.alertSuccess();

    navigate('/client/state');
  };

  useEffect(() => {
    setParam(resultData);
  }, []);

  return (
    <ComplaintWrap>
      <main className='content'>
        <div className='card'>
          <strong>Customer Requests</strong>
          <div className='request-list'>
            <div className='request-form'>
              <div className='form-in'>
                <label htmlFor='area'>Area</label>
                <input value={resultData?.patrolArea}/>
              </div>
              <div className='form-in'>
                <label htmlFor='complaint'>Complaint</label>
                <textarea
                  name='complaint'
                  id='complaint'
                  readOnly={true}
                  value={resultData?.complaint}
                />
              </div>
              <div className='form-in'>
                <label htmlFor='complaint'>Reply</label>
                <textarea
                  name='reply'
                  id='reply'
                  value={param?.reply}
                  onChange={e =>
                    setParam(() => {
                      return {
                        ...param,
                        reply: e.target.value
                      }
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className='btn-desc'>
            <button
              className='write-btn'
              type='button'
              onClick={patchComplaint}
            >
              Write
            </button>
            <button
              className='cancel-btn'
              type='button'
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
          </div>
        </div>
      </main>
    </ComplaintWrap>
  );
}

const ComplaintWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position: relative;
    padding: 20px;
    height: 100vh;
    overflow-y: auto;


    .card {
      background: #fff;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      height: 100%;
      overflow-y: auto;

      strong {
        display: block;
        font-size: 18px;
        font-weight: 700;
        color: #111827;
      }

      .btn-desc {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 15px 0;


        button {
          display: block;
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-weight: 700;
          font-size: 18px;
          border-radius: 10px;
          color: #fff;

          &.write-btn {
            background: #0072B9;
          }

          &.cancel-btn {
            background: #474747;
          }
        }
      }

      .request-list {
        margin-top: 15px;

        .form-in {
          position: relative;
          padding: 15px 0;
          display: flex;
          align-items: center;
          gap: 0 20px;

          label {
            display: block;
            width: 200px;
          }

          input, select {
            width: 100%;
            height: 40px;
            padding: 0 20px;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
            outline: none;
          }

          input[type="date"] {
            background: url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/renewal/icon/calendar.svg') top 50% right 10px no-repeat;
            background-size: 18px 18px;
          }

          input[type="date"]::-webkit-calendar-picker-indicator {
            display: none;
          }

          select {
            background: url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/renewal/icon/chevron-down.svg') top 50% right 10px no-repeat;
            background-size: 18px 18px;
          }

          textarea {
            width: 100%;
            min-height: 240px;
            padding: 0 20px;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
          }
        }
      }
    }
  }
`;
